import { Message } from '../types';
import { Box, Radio, RadioGroup, FormControlLabel, FormControl } from '@mui/material';
import { containerMessage, container, messageAfter } from './styles';
import useStore from '~/store';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface Props {
  content?: Message['content'];
  author?: Message['author'];
  questionComponent?: Message['questionComponent'];
  Component?: Message['Component'];
}

const MATERIALS = [
  {
    value: 1,
    label: 'Aço ou alumínio'
  },
  {
    value: 2,
    label: 'Carbono'
  }
];

export const EquipmentMaterial = ({ content: _content }: Props) => {
  const { setEquipmentMaterial, quote } = useStore((store) => ({
    quote: store.quote,
    setEquipmentMaterial: store.setEquipmentMaterial
  }));

  const { equipmentMaterial } = quote;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEquipmentMaterial(Number(event.target.value));
  };

  return (
    <Box sx={container}>
      <Box sx={() => containerMessage()}>
        <FormControl>
          <RadioGroup
            aria-labelledby="radio-button-equipment-material"
            value={equipmentMaterial}
            onChange={handleChange}
          >
            {MATERIALS.map(({ value, label }) => (
              <FormControlLabel
                key={value}
                value={value}
                label={label}
                control={
                  <Radio inputProps={{ 'aria-label': label }} checkedIcon={<CheckCircleIcon color="success" />} />
                }
              />
            ))}
          </RadioGroup>
        </FormControl>
        <Box sx={messageAfter} />
      </Box>
    </Box>
  );
};
